import React from 'react'

export default function ReportsUserStat() {
  return (
    <div>
      <h2>Thống kê người dùng</h2>
    </div>
  )
}
